import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBQdkRXdBmrWwUtfkDeUjfg_znV-eDvCTE",
  authDomain: "japan-info-jobs-26946.firebaseapp.com",
  databaseURL: "https://japan-info-jobs-26946.firebaseio.com",
  projectId: "japan-info-jobs-26946",
  storageBucket: "japan-info-jobs-26946.appspot.com",
  messagingSenderId: "433574549728",
  appId: "1:433574549728:web:4f480c4ab1442a3f"
};

firebase.initializeApp(firebaseConfig);
firebase.firestore().settings({ timestampsInSnapshots: true });

export default firebase;
